export default "__VITE_ASSET__CiA80Yro__"